<template>
  <v-container>
    <v-row>
      <v-col
        v-if="!$store.state.mobile"
        cols="auto"
      >
        <div style="width:240px">
          <div class="grey lighten-4 pa-4">
            <div class="text-h3 font-medium">
              <template v-if="$store.getters.languageGetter === '1'">
                حسابي
              </template>
              <template v-else>
                My Account
              </template>
            </div>
            <v-list
              dense
              class="grey lighten-4"
            >
              <v-list-item-group>
                <v-list-item
                  v-for="(menu, i) in menus"
                  :key="i"
                  :to="menu.url"
                  class="my-2"
                >
                  <v-list-item-title>{{ menu.text }}</v-list-item-title>
                </v-list-item>
                <v-list-item
                  class="my-2"
                  @click="logOut"
                >
                  <v-list-item-title>
                    <template v-if="$store.getters.languageGetter === '1'">
                      تسجيل خروج
                    </template>
                    <template v-else>
                      Log Out
                    </template>
                  </v-list-item-title>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </div>
        </div>
      </v-col>
      <v-col>
        <router-view />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'User',
  data() {
    return {
    };
  },
  computed: {
    menus() {
      return [
        {
          url: { name: 'UserDashboard' },
          text: this.$store.getters.languageGetter === '1' ? 'لوحة القيادة' : 'Dashboard',
        },
        {
          url: { name: 'UserOrderList' },
          text: this.$store.getters.languageGetter === '1' ? 'طلباتي' : 'My Orders',
        },
        {
          url: { name: 'UserFavoriteList' },
          text: this.$store.getters.languageGetter === '1' ? 'مفضلتي' : 'My Favorites',
        },
        {
          url: { name: 'UserAddressList' },
          text: this.$store.getters.languageGetter === '1' ? 'دليل العناوين' : 'Address book',
        },
        {
          url: { name: 'UserAccountSettings' },
          text: this.$store.getters.languageGetter === '1' ? 'إعدادات الحساب' : 'Account Settings',
        },
      ];
    },
  },
  methods: {
    ...mapActions(['logOutAsync']),
    logOut() {
      this.$store.commit('SET_MINI_LOADING');
      this.logOutAsync().finally(() => {
        this.$store.commit('SET_MINI_LOADING');
      });
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
